var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", [
      _vm._v(
        "Welcome " +
          _vm._s(_vm.currentUser.firstName) +
          " " +
          _vm._s(_vm.currentUser.lastName)
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }